import React from "react";
import { FormattedMessage } from "react-intl";
import { Props as FormattedMessageProps } from "react-intl/src/components/message";
import { Button, PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";

import { WaIcon } from "../WaIcon";

interface Props {
    id: string;
    titleMessage?: FormattedMessageProps;
    bodyMessage: FormattedMessageProps;
}

export const InfoPopover = ({ id, titleMessage, bodyMessage }: Props) => {
    return (
        <div className="info-popover">
            <Button
                color="link"
                id={id}
                className="info-popover__button"
                onClick={(e) => (e.currentTarget as HTMLButtonElement).focus()}
            >
                <WaIcon name="info" />
            </Button>
            <UncontrolledPopover
                placement="left"
                target={id}
                trigger="focus"
            >
                {titleMessage != null && (
                    <PopoverHeader>
                        <FormattedMessage {...titleMessage} />
                    </PopoverHeader>
                )}
                <PopoverBody className="info-popover__body">
                    <FormattedMessage {...bodyMessage} />
                </PopoverBody>
            </UncontrolledPopover>
        </div>
    );
};
